<div class="container">
  <div class="form-row">
    <app-search-lessor-group [formControl]="groupControl"></app-search-lessor-group>
  </div>

  <div class="actions">
    <button mat-stroked-button
            action-button
            color="primary"
            class="delete-button width-100"
            [disabled]="!groupId"
            [action]="unassign.bind(this)">
      Wypisz z grupy
    </button>
    <button mat-raised-button
            action-button
            color="primary"
            class="width-100"
            [disabled]="!groupControl.valid"
            [action]="assign.bind(this)">
      Przypisz grupę
    </button>
  </div>
</div>

